import type { Krok } from "../api/types"
import type { RepeatItem } from "../api/ApiClient"

// -----------------------------
// Completion
// -----------------------------

export type CompletionNextState =
  | "available"
  | "locked"
  | "finished"

// -----------------------------
// Sticker
// -----------------------------

export interface Sticker {
  sticker_id: string
  title: string
  description: string
  priority: number
  full_price_uah: number
  discounted_price_uah: number
  payment_description_uah: string
}

// -----------------------------
// Primary Screens
// -----------------------------

export type PrimaryScreen =
  | { type: "boot" }
  | { type: "auth" }
  | { type: "subscribeAuth" }
  | { type: "subscriptions" }
  | { type: "core" }
  | { type: "completion"
      nextState: CompletionNextState
    }
  | {
      type: "notice"
      noticeType: "next_available" | "locked" | "finished"
      notice: any[]
      nextKrokId: string | null
    } 
  | {
      type: "menu"
      from: Exclude<
        PrimaryScreen,
        { type: "menu" } | { type: "repeatList" }
      >
    }
  | {
      type: "repeatList"
      from: { type: "menu"; from: any }
    }

  | {
      type: "list"
      from: Exclude<
        PrimaryScreen,
        { type: "list" }
      >
    } 

  | {
      type: "account"
      from: Exclude<
        PrimaryScreen,
        { type: "account" }
      >
    }

  | {
    type: "confirmChange"
    data: {
      remaining_days: number
      current_sticker: any
      new_sticker: any
    }
  }

  | {
    type: "confirmCancelSubscription"
  }
    

// -----------------------------
// Gap State
// -----------------------------

export type GapState = {
  [taskIndex: number]: {
    [segmentIndex: number]: string
  }
}

// -----------------------------
// Reveal State
// -----------------------------

export type RevealState = {
  [taskIndex: number]: boolean
}

// -----------------------------
// AppState Root
// -----------------------------

export interface AppState {
  isBooting: boolean
  isLoading: boolean
  error: string | null

  primaryScreen: PrimaryScreen

  currentKrokId: string | null
  krok: Krok | null
  isCurrent: boolean

  repeatItems: RepeatItem[] | null
  expandedLessons: { [lessonId: string]: boolean }

  gaps: GapState
  revealed: RevealState
  scrollY: number

  stickers: Sticker[] | null
  currentSticker: Sticker | null

  // 🔥 выбранная подписка из Landing
  selectedSticker: string | null

    // -----------------------------
  // ACCOUNT
  // -----------------------------

  accountData: {
    email: string
    remaining_new_kroks: number
    current_subscription: {
      remaining_days: number
      next_payment_date: string
    } | null
  } | null

  isAccountLoading: boolean



  // -----------------------------
  // LIST (completed kroks)
  // -----------------------------

  completedLessons: {
    lesson_id: string
    lesson_title: string
    kroks: {
      krok_id: string
      krok_title: string
      }[]
    }[] | null

    isListLoading: boolean


}

// -----------------------------
// Initial State Factory
// -----------------------------

export function createInitialState(): AppState {
  return {
    isBooting: true,
    isLoading: false,
    error: null,

    primaryScreen: { type: "boot" },

    currentKrokId: null,
    krok: null,
    isCurrent: true,

    repeatItems: null,
    expandedLessons: {},

    gaps: {},
    revealed: {},
    scrollY: 0,

    stickers: null,
    currentSticker: null,

    selectedSticker: null,

    completedLessons: null,
    isListLoading: false,

    accountData: null,
    isAccountLoading: false,
  }
}